// extracted by mini-css-extract-plugin
module.exports = {"imgOverlay":"TrainingImages_imgOverlay__nPa2e","source":"TrainingImages_source__Fx5uP","trash":"TrainingImages_trash__SQjn1","badLabel":"TrainingImages_badLabel__004uF"};